import { Component, Input, OnInit } from '@angular/core';
import { IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { isUndefined } from 'util';

@Component({
  selector: 'app-percentuale-redenzione-indicator',
  templateUrl: './percentuale-redenzione-indicator.component.html',
  styleUrls: ['./percentuale-redenzione-indicator.component.css']
})
export class PercentualeRedenzioneIndicatorComponent implements OnInit {

  @Input() data: any;

  constructor(
    private indicatorService: IndicatorsService
  ) { }

  ngOnInit() {
    if (!isUndefined(this.data)) {
      this.indicatorService.indicatorCalculation('PercentualeRedenzione', this.data).subscribe((res) => {
        console.log('PercentualeRedenzione', res);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/points/percentuale-redenzione-indicator/percentuale-redenzione-indicator.component.ts